import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { Component } from "react";
import { connect } from "react-redux";
import { postUserSettingsLocalDrafts } from "./../redux/actions";

class Drafts extends Component {
  constructor(props) {
    super(props);
    this.apiClass = props.apiClass;
  }

  draftClicked = (index) => {
    this.props.history.push(`/${this.props.mailbox}/compose/draft/${index}`);
  };

  deleteDraft = async (index) => {
    let Drafts = Array.from(this.props.getUserSettingsLocalDrafts);
    Drafts.splice(index, 1);
    Drafts = Drafts.filter((i) => i !== null);
    this.props.postUserSettingsLocalDrafts(Drafts);
    return await this.apiClass.PostUserSettings(
      process.env.REACT_APP_ID,
      Drafts
    );
  };

  render() {
    return (
      <div>
        {this.props.drafts.length > 0 ? (
          <List>
            {this.props.drafts.map((x, index) => {
              if (x !== null)
                return (
                  <ListItem
                    key={index}
                    button
                    onClick={(i) => {
                      this.draftClicked(index);
                    }}
                    style={{
                      display: "block",
                      borderTop: "2px solid darkgray",
                      backgroundColor: "lightgray"
                    }}
                    align-items="flex-start"
                    message={x}
                  >
                    <div style={{ display: "inline-flex", width: "100%" }}>
                      <div>
                        <div>
                          <b>To: </b>
                          {x.toAddresses}
                        </div>
                        <div>
                          <b>Subject: </b>
                          {x.subject}
                        </div>
                        <div>
                          <b>Body: </b>
                          {x.body}
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          right: "25px",
                          top: "34px",
                          margin: "auto"
                        }}
                      ></div>
                    </div>
                    <ListItemSecondaryAction>
                      <IconButton onClick={() => this.deleteDraft(index)}>
                        <DeleteIcon
                          style={{ fontSize: "30px", marginRight: "4px" }}
                        />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              else return "";
            })}
          </List>
        ) : (
          <p>You do not have any draft messages</p>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    getUserSettingsLocalDrafts: state.User.Settings.Local.Drafts
  };
}
const mapDispatchToProps = { postUserSettingsLocalDrafts };

export default connect(mapStateToProps, mapDispatchToProps)(Drafts);
